import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Button, Form, Icon, Message} from 'semantic-ui-react';
import {isNil} from 'ramda';
import {findSchool} from '../../api';
import {FormInputLogin} from './FormInputMix';
import {ButtonsGroup, DefaultButton, GreenButton} from '../Button/ButtonMix';

class FindSchoolForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      error: null,
      schoolCode: null,
      schoolCodeError: null,
      selectedSchool: null
    };
  }
  
  handleChange = (e, {name, value}) => this.setState({[name]: value});
  
  handleSubmit = () => {
    this.setState({error: null, schoolCodeError: null, selectedSchool: null});
    const {schoolCode} = this.state;
    
    // validate school code
    const isSchoolCodeValid = schoolCode && schoolCode.length === 6;
    this.setState({schoolCodeError: !isSchoolCodeValid ? 'Invalid school code (code must be 6 characters long)' : null});
    
    if (!isSchoolCodeValid) return;
    
    return findSchool(schoolCode)
      .then(response => {
        this.setState({selectedSchool: response.data});
      })
      .catch(e => {
        e.response ? this.setState({error: e.response.data.error}) : this.setState({error: e.message});
      });
  };
  
  render() {
    const {error, schoolCodeError, selectedSchool} = this.state;
    const {router} = this.props;
    
    const isError = !isNil(error) || !isNil(schoolCodeError);
    const schoolName = !isNil(selectedSchool) ? selectedSchool.name : null;
    
    const onJoinSchool = school => school ? router.push(`sign-up/join/schools/${school.id}`) : null;
    
    return (
      <Form error={isError} success={!isNil(selectedSchool)} onSubmit={this.handleSubmit}>
        <FormInputLogin label="School Code" type="text" name="schoolCode" onChange={this.handleChange} placeholder="Enter the 6 character school code" required/>
        <Message error icon>
          <Icon name="times circle"/>
          <Message.Content>
            <Message.Header>Error</Message.Header>
            {[error, schoolCodeError].filter(e => !isNil(e)).join(', ')}
          </Message.Content>
        </Message>
        <Message success icon>
          <Icon name="check"/>
          <Message.Content>
            <Message.Header>School found!</Message.Header>
            Would you like to join "{schoolName}"?
          </Message.Content>
          <Button onClick={() => onJoinSchool(selectedSchool)}>Join</Button>
        </Message>
        <ButtonsGroup>
          <DefaultButton onClick={router.goBack}>Cancel</DefaultButton>
          <GreenButton fluid>Find</GreenButton>
        </ButtonsGroup>
      </Form>
    );
  }
}

FindSchoolForm.propTypes = {
  router: PropTypes.object.isRequired
};

export default withRouter(FindSchoolForm);



// WEBPACK FOOTER //
// ./src/components/Form/FindSchoolForm.js